module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_5.14f936c4.png";